import { render, staticRenderFns } from "./index.vue?vue&type=template&id=e83141b2&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=e83141b2&lang=scss&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=e83141b2&lang=scss"
import style2 from "./index.vue?vue&type=style&index=2&id=e83141b2&lang=scss&scoped=true"
import style3 from "./index.vue?vue&type=style&index=3&id=e83141b2&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e83141b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\projects\\web_h5\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e83141b2')) {
      api.createRecord('e83141b2', component.options)
    } else {
      api.reload('e83141b2', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=e83141b2&scoped=true", function () {
      api.rerender('e83141b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/P2_Page/DynamicPolicy/index.vue"
export default component.exports